import DialogCategory from './DialogCategory'

export default DialogCategory
